var CHILDISH_TAG = 'BlockDemoWithChildTheme';
/**
 * Filters out childish games and returns a new map
 * @param games
 */
function filterChildishGames(games) {
    var filteredMap = new Set();
    for (var _i = 0, _a = Array.from(games.entries()); _i < _a.length; _i++) {
        var _b = _a[_i], id = _b[0], game = _b[1];
        if (!isChildishGame(game)) {
            filteredMap.add(id);
        }
    }
    return filteredMap;
}
/**
 * Returns true/false depending if the game should be
 * considered a childish game or not.
 * @param game
 */
function isChildishGame(game) {
    return game && game.igcTags.includes(CHILDISH_TAG);
}
/**
 * Filters out games that have property authRequired as true for logged out users
 * @param games
 */
function filterAuthRequiredGames(games) {
    var filteredMap = new Set();
    for (var _i = 0, _a = Array.from(games.entries()); _i < _a.length; _i++) {
        var _b = _a[_i], id = _b[0], game = _b[1];
        if (!game.authRequired) {
            filteredMap.add(id);
        }
    }
    return filteredMap;
}
function copyGames(games) {
    var copiedMap = new Set();
    for (var _i = 0, _a = Array.from(games.entries()); _i < _a.length; _i++) {
        var id = _a[_i][0];
        copiedMap.add(id);
    }
    return copiedMap;
}

export { CHILDISH_TAG, copyGames, filterAuthRequiredGames, filterChildishGames, isChildishGame };
